import axios from "axios";
import { useState, useEffect } from "react";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE, withCredentials: true });

export function useFetch(path) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    let on = true;
    setLoading(true);
    api.get(path)
      .then((r) => { if (on) { setData(r.data); setError(null); } })
      .catch((e) => { if (on) setError(e); })
      .finally(() => { if (on) setLoading(false); });
    return () => { on = false; };
  }, [path]);
  return { data, loading, error };
}

export function getChatSessionId() {
  let id = localStorage.getItem("rp_chat_session");
  if (!id) {
    id = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("rp_chat_session", id);
  }
  return id;
}

// SSE streaming chat — calls onDelta per token
export async function streamChat(sessionId, message, onDelta) {
  const res = await fetch(`${BASE}/chat/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ session_id: sessionId, message }),
  });
  if (!res.ok || !res.body) throw new Error("Chat request failed");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data: ")) continue;
      const evt = JSON.parse(line.slice(6));
      if (evt.delta) onDelta(evt.delta);
      if (evt.error) throw new Error(evt.error);
      if (evt.done) return;
    }
  }
}

export function Spinner({ label = "Loading…" }) {
  return null;
}
